const PICK_SYMBOL = "\u0082";
export const spaceToken = { token: " " };
export function chunkEramMessage(input, length) {
    const res = [];
    for (let i = 0; i < input.length; i += length) {
        const chunk = input
            .slice(i, i + length)
            .map((i) => i.token ?? PICK_SYMBOL)
            .join("");
        res.push(chunk);
    }
    return res;
}
export function stringToTokenArray(str) {
    return str
        .toUpperCase()
        .split("")
        .map((token) => ({ token }));
}
export function stringToParsedTokenArray(s) {
    return s.split(/\s+/g).reduce((acc, token) => {
        acc.push({ token });
        return acc;
    }, []);
}
export function getEramMessageElements(tokenArray) {
    const res = structuredClone(tokenArray);
    return res.reduce((acc, cur, i, arr) => {
        if (!cur.token) {
            acc.push(cur);
            return acc;
        }
        const lastElement = acc.at(-1);
        if (!lastElement?.token || arr[i - 1]?.token === " ") {
            if (cur?.token !== " ") {
                acc.push(cur);
            }
        }
        else if (cur.token && cur.token !== " " && lastElement.token) {
            lastElement.token += cur.token;
        }
        return acc;
    }, []);
}
export function isTokenArray(args) {
    return args.every((arg) => "token" in arg);
}
export function formatEramMessage(msg) {
    return msg
        .map((e) => e.token ?? PICK_SYMBOL)
        .join(" ")
        .toUpperCase()
        .trim();
}
export function genericAccept(lines, line1, newInput) {
    return { isSuccess: true, line1, lines, recall: newInput };
}
export function genericCommandResponse(lines) {
    return { lines };
}
export function genericReject(lines, line1, newInput) {
    return { isSuccess: false, line1, lines, recall: newInput };
}
//# sourceMappingURL=eramMessaging.js.map